/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Generic_Endpoints_TitleInputs */



/**
* | output |
* | --- |
* | "Available Endpoints:" |
*
* @param {Scim_Setup_Generic_Endpoints_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_generic_endpoints_title = /** @type {((inputs?: Scim_Setup_Generic_Endpoints_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Generic_Endpoints_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfügbare Endpunkte:")
	return /** @type {LocalizedString} */ ("Available Endpoints:")
});